export default __webpack_public_path__ + "static/media/g_2.2c093dda.jpg";